<div class="menu-indice"><a routerLink="../../../gestionconstanciafirma/{{a_tipo}}">Gestion de Constancias de {{tipo_participante}}</a> / {{nombre_constancia}}</div>
<mdb-card>
    <mdb-card-body>
        <div class="form-row align-items-center">
            <div class="form-group col-md-2">
                <div class="md-form mt-0 mb-0">
                    <input type="text" id="txt_nombre" maxlength="100" [(ngModel)]="txt_nombre" class="form-control" mdbInput>
                    <label for="txt_nombres">Nombre</label>
                </div>
            </div>
            <div class="form-group col-md-2">
              <button mdbBtn type="button" id="btnBuscar" (click)="onBuscar()"  size="sm" color="blue" mdbWavesEffect>
              <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>
            </div>
            <div class="form-group col-md-1">
              Estado:
          </div>
          <div class="form-group col-md-2">
                    <select class="browser-default custom-select" [(ngModel)]="cboEstado" (change)="onChangeEstado()">
                    <option value="0" selected>Todos</option>
                    <option *ngFor="let listEstado of listEstado" [value]="listEstado.c_tabla">{{listEstado.x_valor}}</option>
                    </select>
          </div>
          <div class="form-group col-md-3">
            <button mdbBtn type="button" id="btnObservarTodos" (click)="onObservarTodos()" size="sm" color="grey" mdbWavesEffect>
            <mdb-icon fas icon="ban" class="mr-1"></mdb-icon>OBSERVAR TODOS</button>
          </div>
            <div class="form-group col-md-2">
              <button mdbBtn type="button" id="btnFirmarTodos" (click)="onFirmarTodos()" size="md" color="teal" mdbWavesEffect>
              <mdb-icon fas icon="file-signature" class="mr-1"></mdb-icon>FIRMAR EN BLOQUE</button>
            </div>
        </div>

    </mdb-card-body>
  </mdb-card>
  <br/>
  <mdb-card>
    <div class="table-responsive">
    <table mdbTable hover="true" class="table">
        <thead>
          <tr>
            <th *ngFor="let head of headElements" scope="col">{{head}}</th>
          </tr>
        </thead>
        <tbody>
          <tr mdbTableCol *ngFor="let listParti of listParticipantes | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
            <th>{{i + 1+ (page-1)*10}}</th>
            <th>{{listParti.x_nombres}}</th>
            <td>{{listParti.x_estado}}</td>
            <td>
            <button *ngIf="listParti.x_uid != 0" [color]="listParti.c_estado == 30?'green': listParti.c_estado == 29?'grey':'orange'" routerLink="../../../firmado/f/{{listParti.c_participante}}" type="button" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="file-pdf" size="lg"></mdb-icon></button>
            </td>
            <td><button *ngIf="listParti.x_uid != 0 && listParti.c_estado == 28"  routerLink="../../../firmar/{{a_tipo}}/{{listParti.c_firma}}" type="button" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="signature" size="lg"></mdb-icon></button></td>
            <td><button *ngIf="listParti.c_estado == 28" (click)="onObservar(listParti.c_participante,listParti.c_firma)" type="button"  color="grey" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="ban" size="md"></mdb-icon></button></td>
          </tr>
        </tbody>
      </table>

      </div>
        <div class="text-center">

          <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
            [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listParticipantes.length">
          </ngb-pagination>

        </div>

  </mdb-card>
